import axios, { AxiosError } from 'axios';
import { PlaygroundData, PlaygroundParams } from '../types/playground';

const API_BASE_URL = 'https://5ep64owpod.execute-api.us-east-1.amazonaws.com/jwt';


export class PlaygroundService {
  private static readonly timeout = 20000; // 20 seconds timeout

  static async getPlaygroundURL(params: PlaygroundParams): Promise<PlaygroundData>{
    try {
      const response = await axios.get<PlaygroundData>(`${API_BASE_URL}/playground`, {
        params: {
          notebook_name: params.notebook_name,
          username: params.username
        },
        timeout: this.timeout
      });
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;
      if (axiosError.response) {
        console.error('Status:', axiosError.response.status);
        console.error('Data:', axiosError.response.data);
      }
      throw error;
    }
  }
}